import React, { useState, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import "./DesktopIcons.css";

const initialIcons = [
  { src: "/txt.png", name: "qui suis je??.txt", type: "textfile" },
  { src: "/icon2.png", name: "Vertbaudet", type: "folder-video" },
  { src: "/icon1.png", name: "prods", type: "folder-audio" },

  { src: "/pdf.png", name: "     CV.pdf", type: "pdf" },
  { src: "/applemusic.png", name: "Ma Playlist", type: "playlist" },
  { src: "/Trash.png", name: "projets\nabandonnés", type: "trash" },
  { src: "/logokarel.png", name: "logo.png", type: "image" }
];

const generateRandomPositions = () => {
  const positions = [];
  const iconWidth = 150;
  const iconHeight = 150;
  const padding = 20;
  const edgeMargin = 100;
  
  const minX = edgeMargin;
  const maxX = window.innerWidth - iconWidth - edgeMargin;
  const minY = 120 + edgeMargin;
  const maxY = window.innerHeight - iconHeight - edgeMargin;

  const isOverlapping = (newPos, existingPositions) => {
    return existingPositions.some(pos => {
      return (
        Math.abs(newPos.x - pos.x) < iconWidth + padding &&
        Math.abs(newPos.y - pos.y) < iconHeight + padding
      );
    });
  };

  for (let i = 0; i < initialIcons.length; i++) {
    let position;
    let attempts = 0;
    const maxAttempts = 200;

    do {
      position = {
        x: Math.random() * (maxX - minX) + minX,
        y: Math.random() * (maxY - minY) + minY
      };
      attempts++;
    } while (isOverlapping(position, positions) && attempts < maxAttempts);

    if (attempts < maxAttempts) {
      positions.push(position);
    } else {
      positions.push({ x: minX + i * 160, y: minY });
    }
  }

  return positions;
};

export default function DesktopIcons({ 
  openFinder, 
  openTextFile, 
  openAudioFolder, 
  openVideoFolder, 
  openPDF, 
  openImageViewer, 
  onTrashDrop, 
  handleOpenPlaylist,
  onWorkInProgress 
}) {
  const [icons, setIcons] = useState(() => 
    initialIcons.map((icon, index) => {
      const positions = generateRandomPositions();
      return {
        ...icon,
        id: index,
        position: positions[index] || { x: 100 + index * 160, y: 220 }
      };
    })
  );

  const [draggedOverTrash, setDraggedOverTrash] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const trashRef = useRef(null);

  const handleStart = () => {
    setIsDragging(false);
  };

  const handleDrag = (e, data, id) => {
    setIsDragging(true);
    
    const trashIcon = icons.find(icon => icon.type === "trash");
    if (!trashIcon || !trashRef.current) return;

    const trashRect = trashRef.current.getBoundingClientRect();
    const iconX = data.x;
    const iconY = data.y;

    const isOverTrash = (
      iconX >= trashRect.left - 50 &&
      iconX <= trashRect.right + 50 &&
      iconY >= trashRect.top - 50 &&
      iconY <= trashRect.bottom + 50
    );

    setDraggedOverTrash(isOverTrash);
  };

  const handleStop = (e, data, id) => {
    if (draggedOverTrash && id !== icons.find(i => i.type === "trash")?.id) {
      // Déplacer l'icône aléatoirement dans un rayon de 100px
      const angle = Math.random() * 2 * Math.PI; // Angle aléatoire en radians
      const distance = 50 + Math.random() * 50; // Distance entre 50 et 100px
      
      const deltaX = Math.cos(angle) * distance;
      const deltaY = Math.sin(angle) * distance;
      
      const newX = data.x + deltaX;
      const newY = data.y + deltaY;
      
      const newIcons = icons.map((icon) =>
        icon.id === id ? { ...icon, position: { x: newX, y: newY } } : icon
      );
      setIcons(newIcons);
      
      if (onTrashDrop) {
        onTrashDrop();
      }
    } else {
      const newIcons = icons.map((icon) =>
        icon.id === id ? { ...icon, position: { x: data.x, y: data.y } } : icon
      );
      setIcons(newIcons);
    }

    setDraggedOverTrash(false);
    
    // Reset isDragging après un court délai
    setTimeout(() => {
      setIsDragging(false);
    }, 100);
  };

  const handleIconClick = (icon) => {
    // N'ouvre que si on n'est PAS en train de drag
    if (isDragging) return;
    
    if (icon.type === "folder-audio") {
      if (icon.name === "à trier" && onWorkInProgress) {
        onWorkInProgress();
      } else {
        openAudioFolder(icon.name);
      }
    } else if (icon.type === "folder-video") {
      openVideoFolder(icon.name);
    } else if (icon.type === "textfile") {
      openTextFile(icon.name);
    } else if (icon.type === "pdf") {
      openPDF();
    } else if (icon.type === "image") {
      openImageViewer(icon.name);
    } else if (icon.type === "playlist") {
      if (onWorkInProgress) {
        onWorkInProgress();
      }
    }
  };

  return (
    <div className="desktop-icons-container">
      {icons.map((icon) => (
        <Draggable
          key={icon.id}
          position={icon.position}
          onStart={handleStart}
          onDrag={(e, data) => handleDrag(e, data, icon.id)}
          onStop={(e, data) => handleStop(e, data, icon.id)}
        >
          <div
            className={`desktop-icon ${icon.type === "trash" && draggedOverTrash ? "trash-hover" : ""}`}
            onClick={() => handleIconClick(icon)}
            ref={icon.type === "trash" ? trashRef : null}
          >
            <img src={icon.src} alt={icon.name} draggable="false" />
            <span className="desktop-icon-label">{icon.name}</span>
          </div>
        </Draggable>
      ))}
    </div>
  );
}
